import React, { useMemo } from 'react';
import { Provider } from 'react-redux';

import configureStore from 'bundles/connect/components/store/configure';
import TaskList from './task_list';
import type { Activity } from 'bundles/connect/types';

type Props = {
  activities: Activity[];
}

export default function TasksIndex(
  { activities }: Props
) {
  const store = useMemo(() => configureStore({ activities }), []);

  return (
    <Provider store={store}>
      <TaskList />
    </Provider>
  );
}
